var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hero',{attrs:{"title":"404","subtitle":"Pagina Non Trovata","text":"Oops! La pagina richiesta non è stata trovata.<br />L'indirizzo che digitato potrebbe non essere corretto oppure questa pagina non esiste più o forse, non è mai esistita."}})
}
var staticRenderFns = []

export { render, staticRenderFns }